/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { makeApi } from "Utils/apiURL";
import { SERVER_URL } from "Static/constant";
import { toasterState } from "Components/common/toaster";
import powerDialerStore from "Stores/powerDialerStore";
import "./powerDialer.scss";

const POLL_MS = 1500;
// AMD reports within a few seconds of answer; stop asking after this.
const POLL_FOR_MS = 45000;

// Click-to-call: once the call is answered, shows "Reached voicemail" + Drop when Twilio detects
// a machine (C2CVoicemail design). Auto drop is done by the backend when the setting allows it.
const C2CVoicemailDrop = ({ callSid = "" }) => {
  const [answeredBy, setAnsweredBy] = useState("");
  const [dropping, setDropping] = useState(false);
  const [dropped, setDropped] = useState(false);
  const { settings, defaultRecording } = powerDialerStore;
  const machine = answeredBy.startsWith("machine_");

  useEffect(() => {
    if (!callSid || !settings.detectVoicemail) return;
    const startedAt = Date.now();
    const timer = setInterval(async () => {
      try {
        const res = await makeApi({ url: `${SERVER_URL}/ds/twilio/call-state/${callSid}` });
        const by = res?.data?.answeredBy || "";
        if (by && by !== "unknown") {
          setAnsweredBy(by);
          clearInterval(timer);
        }
      } catch (e) {}
      if (Date.now() - startedAt > POLL_FOR_MS) clearInterval(timer);
    }, POLL_MS);
    return () => clearInterval(timer);
  }, [callSid, settings.detectVoicemail]);

  const drop = async () => {
    if (dropping || dropped) return;
    setDropping(true);
    try {
      const res = await makeApi({
        url: `${SERVER_URL}/ds/twilio/voicemail/drop`,
        method: "POST",
        data: { callSid, recordingId: defaultRecording?.id || "", auto: false }
      });
      if (res?.data?.status === "success") {
        setDropped(true);
        toasterState.setToastMsg("Voicemail dropped. The call ends once it plays.", "success");
      } else {
        toasterState.setToastMsg(
          res?.data?.status === "no_recording" ? "Record a voicemail first in Dialer settings." : "Couldn't drop the voicemail.",
          "failure"
        );
      }
    } catch (e) {
      toasterState.setToastMsg("Couldn't drop the voicemail.", "failure");
    }
    setDropping(false);
  };

  useEffect(() => {
    if (!machine) return;
    const onKey = e => {
      const t = e.target;
      if (t?.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(t?.tagName)) return;
      if (e.key.toLowerCase() === "v" && !e.metaKey && !e.ctrlKey && !e.altKey) {
        e.preventDefault();
        drop();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [machine, dropping, dropped]);

  if (!machine) return null;
  return (
    <div className="pdC2cVoicemail">
      <div className="pdC2cStatus">
        <i className="material-symbols-outlined">voicemail</i>
        Reached voicemail
      </div>
      {defaultRecording ? (
        <>
          <button type="button" className="pdC2cDrop" disabled={dropping || dropped} onClick={drop}>
            {dropped ? "Voicemail dropped" : `Drop voicemail “${defaultRecording.name}”`}
            <span className="pdC2cKbd">V</span>
          </button>
          <div className="pdC2cHint">Hangs up for you once it plays. Logs Left voicemail.</div>
        </>
      ) : (
        <div className="pdC2cHint">Record a voicemail in Dialer settings to drop it here.</div>
      )}
    </div>
  );
};

export default observer(C2CVoicemailDrop);
